import { z } from 'zod';

const facts = z.record(z.string(), z.json()).nullable();
// Database JSON is an input boundary too; never cast a durable row into an event.
// Preserve canonical projection provenance for the database's exact manifest check.
export const notificationEventSchema = z.looseObject({
  accountId: z.uuid(),
  propertyId: z.uuid(),
  observationRevision: z.number().int().nonnegative(),
  issueRevision: z.number().int().nonnegative().nullable(),
  issueIdentity: z.string().nullable(),
  source: z.string().min(1).max(160),
  recordKind: z.string().min(1).max(100).nullable(),
  sourceRecordId: z.string().nullable(),
  eventKey: z.string().min(1),
  eventType: z.enum([
    'record_added',
    'record_changed',
    'record_not_listed',
    'source_adopted',
    'source_lost',
    'source_parser_upgraded',
    'source_scope_expanded',
  ]),
  title: z.string(),
  priority: z.enum(['now', 'soon', 'review', 'info']),
  priorityReasons: z.array(z.string()),
  before: facts,
  after: facts,
  rawChanges: z.array(
    z.object({ path: z.string(), before: z.json().optional(), after: z.json().optional() }),
  ),
  evidence: z.object({
    sourceUrl: z.string(),
    links: z.array(z.object({ label: z.string(), url: z.string() })),
  }),
  observedAt: z.iso.datetime(),
});
